import React from 'react';
import Logo from './Logo';

const SuccessDisplay = ({ sessionId }) => {
  return (
    <div className="hero min-h-screen bg-base-200">
      <div className="hero-content text-center">
        <div className="max-w-md">
          <div className="flex justify-center mb-6">
            <div className="text-primary">
              <Logo />
            </div>
          </div>
          <h1 className="text-5xl font-bold text-success">Subscription Successful!</h1>
          <p className="py-6">Thank you for subscribing. Your account has been updated successfully.</p>
          <form action="/create-portal-session" method="POST">
            <input
              type="hidden"
              id="session-id"
              name="session_id"
              value={sessionId}
            />
            <button className="btn btn-primary" type="submit">
              Manage your billing information
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SuccessDisplay;
